import styled from "styled-components";

export const TestItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Test = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TestImg = styled.div`
  overflow: hidden;
  width: 140px;
  height: 200px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.black5};

  img {
    width: 140px;
    height: 200px;
    object-fit: cover;
    object-position: center;
  }
`;

export const TestInfoBox = styled.div`
  display: flex;
  width: 140px;
  padding: 0 10px;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`;

export const TestTitle = styled.div`
  display: flex;
  width: 120px;
  align-items: center;
  justify-content: space-between;
  gap: 6px;

  span {
    overflow: hidden;
    display: inline-block;
    width: 96px;
    font-size: 1.6rem;
    font-weight: 500;
    font-family: "Pretendard";
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  svg {
    path {
      fill: ${(props) => props.theme.colors.black50};
    }
  }
`;

export const TextStatus = styled.div`
  display: flex;
  width: 120px;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-family: "Pretendard";
  flex-direction: column;
  gap: 6px;
`;
